var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCursorFinger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.578 9.053-3.578-.716v-4.337a4 4 0 0 0 -8 0v4.45l-3.722 4.523a5.3 5.3 0 0 0 .262 7.17l2.2 2.224a5.536 5.536 0 0 0 3.91 1.633h7.85a5.506 5.506 0 0 0 5.5-5.5v-4.054a5.513 5.513 0 0 0 -4.422-5.393zm1.422 9.447a2.5 2.5 0 0 1 -2.5 2.5h-7.85a2.521 2.521 0 0 1 -1.778-.742l-2.2-2.23a2.3 2.3 0 0 1 -.094-3.123l1.422-1.734v3.329a1.5 1.5 0 0 0 3 0v-12.5a1 1 0 0 1 2 0v5.566a1.5 1.5 0 0 0 1.206 1.471l4.784.957a2.508 2.508 0 0 1 2.01 2.452z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCursorFinger);
export default __webpack_public_path__ + "static/media/cursor-finger.be847a531ffb84dabbcf355f9de3ac48.svg";
export { ForwardRef as ReactComponent };